import { render, staticRenderFns } from "./math-lessons-page.vue?vue&type=template&id=6ff9c5cb&"
import script from "./math-lessons-page.vue?vue&type=script&lang=js&"
export * from "./math-lessons-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports